import { redeemVoucher, redeemVoucherByEmail } from '../api/voucher';
import { createAction } from 'redux-actions';
import ActionTypes from '../constants/ActionTypes';
import { SubmissionError } from 'redux-form';
import { push } from 'react-router-redux';
import Socium from '../constants/Socium';
import Cookies from 'universal-cookie';
import Convert from '../utils/convert';
import { isValidLength } from '../utils/validation';

const submitInstallForm = form => {
  return async (dispatch, getState) => {
    const store = getState();
    const { pending } = store.install;
    const formVoucher = form.install_voucher || '';
    const voucher = formVoucher;
    const formPurchaseDate = form.pdate || '';
    const purchaseDate = Convert.date(formPurchaseDate);
    const validLength = [14];
    let voucherRedeem = Convert.voucher(voucher);
    // validate code
    if (isValidLength(voucherRedeem.length, validLength)) {
      voucherRedeem = voucherRedeem + purchaseDate;
    }

    if (pending) {
      if (purchaseDate.length !== 8 && voucherRedeem.length === 14) {
        throw new SubmissionError({
          install_voucher_error: 'Please choose a purchase date.'
        });
      }

      dispatch(createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_REQUEST)());
      resetTokenFromCookie();

      try {
        const { data } = await redeemVoucher(voucherRedeem);

        if (data.status === 0 && data.token) {
          setCookieToken(data.token);
          dispatch(createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_SUCCESS)(data));
          const extraInstallData = {
            voucher: formVoucher,
            date: formPurchaseDate,
            categories: data.categories,
            canRemove: false
          };
          dispatch(createAction(ActionTypes.EXTRA_INSTALL_VOUCHER_VALIDATE_INIT)(extraInstallData));
        }

        // already redeemed
        if (data.status === 1) {
          dispatch(createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_USED)(data));
        }

        dispatch(createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_DONE)());
      } catch (e) {
        dispatch(createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_DONE)());

        throw new SubmissionError({
          install_voucher_error:
            'Sorry, there was a problem with your install code. Please call install support on 1300 043 520',
          install_voucher: true,
          pdate: true
        });
      }

      return;
    }

    // validate email
    const email = form.install_email || '';

    if (!email) {
      throw new SubmissionError({
        install_email: 'Please specify your email'
      });
    }

    try {
      const { data } = await redeemVoucherByEmail(voucherRedeem, email);

      if (data.token && data.jobId) {
        setCookieToken(data.token);
        dispatch(
          createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_USED_VALIDATE_SUCCESS)(data.token)
        );

        // jump to success page
        dispatch(push(`./success/${data.jobId}`));
      }
    } catch (e) {
      dispatch(createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_DONE)());

      throw new SubmissionError({
        install_email: 'Email is not valid'
      });
    }

    dispatch(createAction(ActionTypes.INSTALL_VOUCHER_VALIDATE_DONE)());
  };
};

const setCookieToken = token => {
  const cookies = new Cookies();
  cookies.set(Socium.COOKIE_TOKEN, token, {
    path: '/'
  });
};

const resetTokenFromCookie = () => {
  const cookies = new Cookies();
  cookies.remove(Socium.COOKIE_TOKEN, {
    path: '/'
  });
};
export const backToFirstScreen = () => {
  return dispatch => {
    dispatch(createAction(ActionTypes.INSTALL_VOUCHER_RESET)());
    resetTokenFromCookie();
  };
};

export const setInstallToken = token => {
  return dispatch => {
    const cookies = new Cookies();
    const jobToken = token || cookies.get(Socium.COOKIE_TOKEN);
    setCookieToken(jobToken);
    dispatch(createAction(ActionTypes.INSTALL_VOUCHER_TOKEN_UPDATE)(jobToken));
  };
};

export const continueToEnquire = catKey => {
  return dispatch => {
    // jump to job post page
    dispatch(push(`./request_quote?cat=${catKey}`));
  };
};

export default {
  continueToEnquire,
  setInstallToken,
  submitInstallForm,
  backToFirstScreen
};
